<template>
  <div class="line-tab-wrap nd-mobile-tab">
    <div
      v-for="(tab, index) in tabs"
      :key="tab.value"
      :class="['line-tab', currentTab === tab.value ? 'on' : '']"
      @click="onTabClick(tab.value)"
    >
      {{ tab.label }}
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{ modelValue: string }>();
const emit = defineEmits<{ 'update:modelValue': [value: string] }>();

const items = [
  { label: '결제 내역', value: 'PAYMENT' },
  { label: '크레딧 사용 내역', value: 'CREDIT' },
];

const tabs = computed(() => items.map(({ label, value }) => ({ label, value })));

const currentTab = computed(() => props.modelValue);

const onTabClick = (value) => {
  emit('update:modelValue', value);
};
</script>

<style scoped lang="scss">
.nd-mobile-tab {
  display: none;
  margin-bottom: 40px;
}
@include respond-to(mobile-portrait) {
  .nd-mobile-tab {
    display: flex;
  }
}
</style>
